// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"59":"cf52654e","342":"2d78bb5c"}[chunkId] + ".chunk.css";
};